// Bridge the brief thinking gaps between browser calls without treating a
// browser used earlier in the task as current activity.
export const BROWSER_ACTIVITY_GRACE_MS = 12000;

// Generic action approvals share the browser confirmation transport. Their
// act- IDs do not imply that a cloud browser exists (for example, Mac tests).
export function hasPendingBrowserInteraction({ loginRequest, confirmation } = {}) {
  return !!loginRequest || !!(confirmation && !String(confirmation.id || '').startsWith('act-'));
}

export function workBrowserActivity(events, { active = false, pendingBrowser = false, now = Date.now() } = {}) {
  if (!active) return { live: false, expiresAt: null };
  const pending = [];
  let ended = false, lastWasBrowser = false, lastBrowserEnd = 0;
  for (const event of Array.isArray(events) ? events : []) {
    const type = event?.type, name = String(event?.toolName || event?.name || '');
    if (['session_start', 'session_resume', 'session_end', 'session_finalizing', 'compaction_start'].includes(type) ||
        (type === 'budget_pressure' && event.stage === 'compact')) {
      pending.length = 0; lastWasBrowser = false; lastBrowserEnd = 0;
      ended = type === 'session_end' || type === 'session_finalizing';
    } else if (type === 'tool_execution_start') {
      lastWasBrowser = name.startsWith('browser_');
      if (lastWasBrowser && !pending.some(item => event.toolCallId && item.toolCallId === event.toolCallId)) pending.push(event);
    } else if (type === 'tool_execution_end') {
      const index = pending.findLastIndex(start => event.toolCallId ? start.toolCallId === event.toolCallId
        : name ? (start.toolName || start.name) === name : true);
      if (index >= 0) {
        pending.splice(index, 1);
        lastBrowserEnd = Date.parse(event.ts) || 0;
      }
    }
  }
  if (ended) return { live: false, expiresAt: null };
  if (pendingBrowser || pending.length) return { live: true, expiresAt: null };
  const expiresAt = lastWasBrowser && lastBrowserEnd ? lastBrowserEnd + BROWSER_ACTIVITY_GRACE_MS : null;
  return { live: !!expiresAt && expiresAt > now, expiresAt: expiresAt > now ? expiresAt : null };
}
